// Shared by curves of the same degree/precision. Bound retained memory even
// when a freehand sketch continually changes the number of control points.
var CACHE_BYTES = 8 * 1024 * 1024;
var bases = [];
var cachedBytes = 0;
function basisFor(count, steps) {
    for (var i = 0; i < bases.length; i++) {
        var entry = bases[i];
        if (entry.count === count && entry.steps === steps) {
            if (i !== bases.length - 1) {
                bases.splice(i, 1);
                bases.push(entry);
            }
            return entry.weights;
        }
    }
    var weights = new Float64Array((steps - 1) * count);
    var degree = count - 1;
    var ratios = new Float64Array(degree);
    for (var i = 0; i < degree; i++)
        ratios[i] = (degree - i) / (i + 1);
    // B_i(t) = B_(degree-i)(1-t): evaluate the first half and mirror its rows.
    // Here t <= 0.5, so the recurrence never divides by a vanishing (1-t).
    // At the supported maximum degree, even the midpoint weight is safe.
    for (var sample = 1; sample * 2 <= steps; sample++) {
        var t = sample / steps;
        var ratio = t / (1 - t);
        var weight = Math.pow((1 - t), degree);
        var sum = 0;
        var offset = (sample - 1) * count;
        for (var i = 0; i < count; i++) {
            weights[offset + i] = weight;
            sum += weight;
            if (i < degree)
                weight *= ratios[i] * ratio;
        }
        // Preserve the partition of unity despite rounding in the recurrence.
        for (var i = 0; i < count; i++)
            weights[offset + i] /= sum;
        var mirrorOffset = (steps - sample - 1) * count;
        if (mirrorOffset !== offset) {
            for (var i = 0; i < count; i++) {
                weights[mirrorOffset + degree - i] = weights[offset + i];
            }
        }
    }
    if (weights.byteLength <= CACHE_BYTES) {
        while (cachedBytes + weights.byteLength > CACHE_BYTES) {
            var oldest = bases.shift();
            if (oldest)
                cachedBytes -= oldest.weights.byteLength;
        }
        bases.push({ count: count, steps: steps, weights: weights });
        cachedBytes += weights.byteLength;
    }
    return weights;
}
export function _sampleBezier(points, dimension, increment, vertices) {
    var _a;
    if (!Number.isFinite(increment) || increment <= 0) {
        throw new Error('[p5.bezier] The sampling increment must be positive and finite');
    }
    var steps = Math.max(1, Math.round(1 / increment));
    var count = points.length;
    var weights = basisFor(count, steps);
    vertices.length = steps + 1;
    for (var sample = 0; sample <= steps; sample++) {
        var vertex = (_a = vertices[sample]) !== null && _a !== void 0 ? _a : (dimension === 3 ? [0, 0, 0] : [0, 0]);
        vertices[sample] = vertex;
        if (sample === 0 || sample === steps) {
            var point = points[sample === 0 ? 0 : count - 1];
            vertex[0] = point[0];
            vertex[1] = point[1];
            if (dimension === 3)
                vertex[2] = point[2];
            continue;
        }
        var x = 0;
        var y = 0;
        var offset = (sample - 1) * count;
        if (dimension === 2) {
            for (var i = 0; i < count; i++) {
                var weight = weights[offset + i];
                var point = points[i];
                x += weight * point[0];
                y += weight * point[1];
            }
        }
        else {
            var z = 0;
            for (var i = 0; i < count; i++) {
                var weight = weights[offset + i];
                var point = points[i];
                x += weight * point[0];
                y += weight * point[1];
                z += weight * point[2];
            }
            vertex[2] = z;
        }
        vertex[0] = x;
        vertex[1] = y;
    }
}
